import type { JSX } from 'react';

import { withPrefetchedData } from '@change-corgi/core/react/prefetch';
import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';

import type { PetitionCommentsPagePrefetchedDataProps } from 'src/app/pages/petition/comments/pageContext';
import { PetitionCommentsPageContextProvider, prefetchPageContext } from 'src/app/pages/petition/comments/pageContext';

import { Layout } from '../layout';

import { PetitionCommentsErrorHandler } from './ErrorHandler';

export const PetitionComments = withPrefetchedData(
	function PetitionComments({ prefetchedData }: PetitionCommentsPagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<PetitionCommentsPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PetitionCommentsErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PetitionCommentsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
